import type { M365Acquisition } from "owa-graph-schema";
import { hasExchangeAddIn } from "./hasExchangeAddIn";
import { hasExtensionAddIn } from "./hasExtensionAddIn";

export function hasAddin(acquisition: M365Acquisition): boolean {
    return hasExtensionAddIn(acquisition) || hasExchangeAddIn(acquisition);
}
